import type { PreClaimsFullReleaseListResponse } from './api';

export const normalizePreClaimsFullReleaseList = (
  list: PreClaimsFullReleaseListResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.value,
    value: row.key,
  }));
};
